import * as React from 'react';
import { StyledSystemProps } from '../../../theme/StyledSystemProps';
import Box from '../primitives/Box';

type FieldRowProps = StyledSystemProps & {
  children: React.ReactNode;
  color?: string;
  flex?: string | number;
};

const FieldRow: React.FC<FieldRowProps> = props => {
  return (
    <Box flexDirection="row" {...props}>
      {props.children}
    </Box>
  );
};

export default FieldRow;

FieldRow.defaultProps = {
  flex: 1,
  flexWrap: 'wrap',
  width: '100%',
};
